/**
 * Store Location Selector - Hardcoded Version
 * Add this to assets/store-location-selector.js
 */

// Hardcoded store data
const HARDCODED_STORES = {"message":"Success","error":false,"data":[{"userId":6126,"storeName":"004-TORONTO","homePhone":"","workPhone":"416-782-5900","address":"65 Dufflaw Rd.","postalCode":"M6A 2W4","province":"Ontario","city":"Toronto"},{"userId":6124,"storeName":"008-MISSISSAUGA","homePhone":"","workPhone":"905-766-3417","address":"600 Matheson Blvd. W","postalCode":"L5R 4B8","province":"Ontario","city":"Mississauga"},{"userId":6132,"storeName":"009-OTTAWA WEST","homePhone":"","workPhone":"613-224-5900","address":"1547 Merivale Rd.","postalCode":"K2G 4V3","province":"Ontario","city":"Ottawa"},{"userId":6123,"storeName":"010-HAMILTON/STONEYCREEK","homePhone":"","workPhone":"905-525-1111","address":"442 Millen Rd.","postalCode":"L8E 6H2","province":"Ontario","city":"Hamilton"},{"userId":6129,"storeName":"013-WHITBY","homePhone":"","workPhone":"905-233-2448","address":"150 Taunton Rd. W","postalCode":"L1R 3H8","province":"Ontario","city":"Whitby"},{"userId":6127,"storeName":"014-KITCHENER","homePhone":"","workPhone":"519-279-6844","address":"4336 King St. E","postalCode":"N2P 3W6","province":"Ontario","city":"Kitchener"},{"userId":6130,"storeName":"015-LONDON","homePhone":"","workPhone":"519-266-4533","address":"1230 Wellington Rd.","postalCode":"N6E 1M3","province":"Ontario","city":"London"},{"userId":6128,"storeName":"016-MARKHAM","homePhone":"","workPhone":"905-475-7530","address":"8261 Woodbine Ave.","postalCode":"L3R 8Z5","province":"Ontario","city":"Markham"},{"userId":9250,"storeName":"018-LONGUEUIL","homePhone":"","workPhone":"450-999-1757","address":"2908 Ch de Chambly","postalCode":"J4L 1N1","province":"Quebec","city":"Longueuil"},{"userId":9249,"storeName":"019-LAVAL (STORE&DC)","homePhone":"","workPhone":"450-624-2950","address":"1340 boul. Dagenaris Ouest","postalCode":"H7L 5C7","province":"Quebec","city":"Laval"},{"userId":9248,"storeName":"020-OTTAWA EAST","homePhone":"","workPhone":"613-627-3412","address":"100 Trainyards Dr.","postalCode":"k1G 4V3","province":"Ontario","city":"Ottawa East"},{"userId":9255,"storeName":"021-CALGARY (STORE&DC)","homePhone":"","workPhone":"403-456-2447","address":"2777, 23 Ave. NE","postalCode":"?T1Y 7L6","province":"Alberta","city":"CALGARY"},{"userId":9244,"storeName":"022-VAUGHAN","homePhone":"","workPhone":"289-843-5022?","address":"7575 Weston Rd","postalCode":"L4L 9K5","province":"Ontario","city":"Woodbridge"},{"userId":9251,"storeName":"023-QUEBEC","homePhone":"","workPhone":"581-705-9579","address":"1100 ru Bouvier","postalCode":"G2K 1L9","province":"Quebec","city":"Ville de Quebec"},{"userId":9254,"storeName":"024-EDMONTON","homePhone":"","workPhone":"780-328-3770","address":"3803 Calgary Trail NW","postalCode":"T6J 5M8","province":"Alberta","city":"Edmonton"},{"userId":9245,"storeName":"026-BRAMPTON","homePhone":"","workPhone":"905-499-1866","address":"30 Great Lakes DR.","postalCode":"L6R 2K7","province":"Ontario","city":"BRAMPTON"},{"userId":9246,"storeName":"027-OAKVILLE","homePhone":"","workPhone":"289-863-1349","address":"3487 Wyecroft rd","postalCode":"L6L 0B6","province":"Ontario","city":"BURLINGTON"},{"userId":9257,"storeName":"028-COQUITLAM","homePhone":"","workPhone":"604-282-0661","address":"101 Schoolhouse St.","postalCode":"V3K 4X8","province":"British Columbia","city":"COQUITLAM"},{"userId":9258,"storeName":"029-SURREY","homePhone":"","workPhone":"778-588-5620","address":"7488 King George Blvd.","postalCode":"V3W 0H9","province":"British Columbia","city":"Surrey"},{"userId":9259,"storeName":"033-VANCOUVER","homePhone":"","workPhone":"604-282-0662","address":"42 E Broadway","postalCode":"V5T 1V6","province":"British Columbia","city":"Vancouver"},{"userId":9256,"storeName":"035-EDMONTON NORTH","homePhone":"","workPhone":"780-328-2541","address":"17235 105 Ave. NW","postalCode":"?T5S 1G4","province":"Alberta","city":"Edmonton North"},{"userId":9252,"storeName":"036-HALIFAX","homePhone":"","workPhone":"902-701-1106","address":"215 Chain Lakes Dr.","postalCode":"b3S 1C9","province":"Nova Scotia","city":"Halifax"},{"userId":9253,"storeName":"037-WINNIPEG","homePhone":"","workPhone":"204-289-9685","address":"1585 Kenaston Blvd.","postalCode":"R3P 2N3","province":"Manitoba","city":"Winnipeg"},{"userId":9243,"storeName":"038-SCARBOROUGH","homePhone":"","workPhone":"416-740-6500","address":"20 Lebovic Ave","postalCode":"M1L 4V9","province":"Ontario","city":"Scarborough"},{"userId":9260,"storeName":"039-CALGARYSOUTH","homePhone":"","workPhone":"403-456-9681","address":"9250 Macleod Trail SE","postalCode":"T2J 0P5","province":"Alberta","city":"CALGARY"},{"userId":6125,"storeName":"050-ETOBICOKE","homePhone":"","workPhone":"416-782-5977","address":"90 Ronson Dr.","postalCode":"M9W 1B6","province":"Ontario","city":"Etobicoke"},{"userId":6133,"storeName":"052-MONTREAL","homePhone":"","workPhone":"514-357-4322","address":"5650 Royalmount Ave.","postalCode":"H4P 1K4","province":"Quebec","city":"Montreal"},{"userId":6131,"storeName":"057-BARRIE","homePhone":"","workPhone":"705-999-6074","address":"468 Bayfield St","postalCode":"L4M 5A2","province":"Ontario","city":"Barrie"},{"userId":9263,"storeName":"CAS-WAREHOUSE","homePhone":"416-782-5900","workPhone":"416-782-5900","address":"845 Intermodal Dr","postalCode":"L6T 5W2","province":"Ontario","city":"BRAMPTON"},{"userId":6228,"storeName":"STORECAS","homePhone":"","workPhone":"000-000-0000","address":"","postalCode":"","province":"","city":""}],"statusCode":200,"isSuccess":true};

class StoreLocationSelector {
  constructor() {
    this.dropdown = null;
    this.storeData = [];
    this.displayArea = null;
    this.init();
  }

  init() {
    // Wait for jQuery and Select2 to be available
    this.waitForDependencies();
  }

  waitForDependencies() {
    const checkInterval = setInterval(() => {
      if (typeof jQuery !== 'undefined' && jQuery.fn.select2) {
        clearInterval(checkInterval);
        console.log('jQuery and Select2 loaded, initializing...');
        this.setup();
      }
    }, 100);

    // Timeout after 10 seconds
    setTimeout(() => {
      clearInterval(checkInterval);
      if (typeof jQuery === 'undefined' || !jQuery.fn.select2) {
        console.error('jQuery or Select2 not loaded. Please include them in your theme.');
      }
    }, 10000);
  }

  setup() {
    this.dropdown = jQuery('#checkout-popup .form-select.f-cart-1');
    
    if (!this.dropdown.length) {
      console.error('Store location dropdown not found');
      return;
    }

    console.log('Dropdown found, setting up Select2...');

    // Create display area
    this.createDisplayArea();

    // Load hardcoded stores
    this.loadHardcodedStores();

    // Initialize Select2
    this.initializeSelect2();

    // Watch for popup open
    this.watchPopupOpen();

    // Prevent checkout without selection
    this.enforceStoreSelection();
  }

  createDisplayArea() {
    const dropdownContainer = this.dropdown.closest('.mb-4');
    if (!dropdownContainer.length) return;

    const displayArea = jQuery('<div class="store-location-display"></div>');
    displayArea.hide();
    dropdownContainer.before(displayArea);
    
    this.displayArea = displayArea;
  }

  loadHardcodedStores() {
    console.log('Loading hardcoded store data...');

    try {
      const data = HARDCODED_STORES;
      
      let stores = [];
      if (data.isSuccess && Array.isArray(data.data)) {
        stores = data.data;
      }

      if (!stores.length) {
        throw new Error('No stores found in hardcoded data');
      }

      this.storeData = stores;
      console.log('Loaded stores:', stores);

      // Populate dropdown
      this.dropdown.empty();
      this.dropdown.append('<option value="">Select a location</option>');
      
      stores.forEach((store, index) => {
        const option = jQuery('<option></option>')
          .val(index)
          .text(`${store.storeName} (${store.city}, ${store.province})`)
          .data('store', store);
        
        this.dropdown.append(option);
      });

    } catch (error) {
      console.error('Failed to load stores:', error);
    }
  }

  initializeSelect2() {
    // Initialize Select2 with custom options
    this.dropdown.select2({
      placeholder: 'Search or select a location...',
      allowClear: true,
      width: '100%',
      dropdownParent: jQuery('#checkout-popup'), // Important for modal/popup
      templateResult: this.formatStoreOption,
      templateSelection: this.formatStoreSelection
    });

    // Listen for selection changes
    this.dropdown.on('select2:select', (e) => {
      const selectedIndex = e.params.data.id;
      const store = this.storeData[parseInt(selectedIndex)];
      
      if (store) {
        console.log('Store selected:', store);
        this.handleStoreSelection(store);
      }
    });

    // Listen for clear
    this.dropdown.on('select2:clear', () => {
      console.log('Selection cleared');
      this.displayArea.hide();
      this.removeCartAttributes();
    });
  }

  formatStoreOption(store) {
    if (!store.id) {
      return store.text;
    }

    // Custom formatting for dropdown options
    const $container = jQuery(
      `<div class="select2-store-option">
        <div class="store-name">${store.text}</div>
      </div>`
    );

    return $container;
  }

  formatStoreSelection(store) {
    return store.text;
  }

  handleStoreSelection(store) {
    // Display store information
    if (this.displayArea) {
      this.displayArea.html(`
        <div class="store-location-info">
          <h3 class="store-location-title">Selling Store Location</h3>
          <div class="store-location-details">
            <p><strong>${store.storeName}</strong></p>
            <p>${store.address}</p>
            <p>${store.city}, ${store.province} ${store.postalCode}</p>
            ${store.workPhone ? `<p>Phone: ${store.workPhone}</p>` : ''}
            ${store.homePhone ? `<p>Alt Phone: ${store.homePhone}</p>` : ''}
          </div>
        </div>
      `);
      this.displayArea.show();
    }

    // Update cart attributes
    this.updateCartAttributes(store);
  }

  async updateCartAttributes(store) {
    const note_attributes = {
      'Store Location': store.storeName,
      'Store ID': store.userId.toString(),
      'Store Address': store.address,
      'Store City': store.city,
      'Store Province': store.province,
      'Store Postal Code': store.postalCode,
      'Store Phone': store.workPhone || store.homePhone || 'N/A'
    };

    console.log('Updating cart note attributes:', note_attributes);

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ note: '', attributes: note_attributes })
      });

      if (response.ok) {
        console.log('Cart note attributes updated successfully');
      } else {
        console.error('Failed to update cart attributes:', response.status);
      }
    } catch (error) {
      console.error('Error updating cart attributes:', error);
    }
  }

  async removeCartAttributes() {
    const note_attributes = {
      'Store Location': '',
      'Store ID': '',
      'Store Address': '',
      'Store City': '',
      'Store Province': '',
      'Store Postal Code': '',
      'Store Phone': ''
    };

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ attributes: note_attributes })
      });
      console.log('Cart note attributes cleared');
    } catch (error) {
      console.error('Failed to remove cart attributes:', error);
    }
  }

  watchPopupOpen() {
    const popup = document.querySelector('#checkout-popup');
    if (!popup) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'aria-hidden') {
          const isHidden = popup.getAttribute('aria-hidden') === 'true';
          if (!isHidden) {
            console.log('Popup opened');
            // Refresh Select2 when popup opens
            setTimeout(() => {
              this.dropdown.select2('open');
              this.dropdown.select2('close');
            }, 100);
          }
        }
      });
    });

    observer.observe(popup, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  enforceStoreSelection() {
    const checkoutButton = jQuery('#checkout-popup #checkout');
    
    if (!checkoutButton.length) {
      console.warn('Checkout button not found in popup');
      return;
    }

    checkoutButton.on('click', (e) => {
      const selectedValue = this.dropdown.val();
      
      if (!selectedValue || selectedValue === '') {
        e.preventDefault();
        e.stopPropagation();
        
        this.showValidationError();
        
        // Highlight Select2 container
        const select2Container = this.dropdown.next('.select2-container');
        select2Container.find('.select2-selection').css('border', '2px solid red');
        
        setTimeout(() => {
          select2Container.find('.select2-selection').css('border', '');
        }, 3000);
        
        // Open Select2 to prompt selection
        this.dropdown.select2('open');
        
        return false;
      }
    });
  }

  showValidationError() {
    const existingError = jQuery('.store-location-error');
    if (existingError.length) {
      existingError.remove();
    }
    
    const errorDiv = jQuery('<div class="store-location-error">⚠️ Please select a pickup location before checkout</div>');
    errorDiv.css({
      'color': 'red',
      'margin-top': '0.5rem',
      'font-size': '0.9rem',
      'font-weight': '600'
    });
    
    this.dropdown.closest('.mb-4').append(errorDiv);
    
    setTimeout(() => {
      errorDiv.fadeOut(() => errorDiv.remove());
    }, 5000);
  }
}

// Initialize only once - prevent double initialization
(function() {
  let initialized = false;
  
  function initialize() {
    if (initialized) {
      console.log('Store selector already initialized, skipping...');
      return;
    }
    
    if (typeof jQuery === 'undefined' || !jQuery.fn.select2) {
      console.error('jQuery or Select2 not loaded');
      return;
    }
    
    initialized = true;
    console.log('Initializing Store Location Selector...');
    new StoreLocationSelector();
  }
  
  // Use only jQuery ready
  jQuery(document).ready(initialize);
})();